import { Component, EventEmitter, OnInit, Output } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { SpraApprovalParams, SpraCsaRate, SPRAPriceRef } from 'src/app/Models/ops';
import { MasterService } from 'src/app/Services/master.service';
import { NotificationService } from 'src/app/Services/notification.service';
import { Utility } from 'src/app/Utilities/utility';
import { SpraListComponent } from '../spra-list/spra-list.component';
import { MatDialog } from '@angular/material/dialog';
import { SpraViewOpsComponent } from '../../spra/spra-view-ops/spra-view-ops.component';
import { Router } from '@angular/router';
import { ViewChild } from '@angular/core';


@Component({
  selector: 'app-spra-approval',
  templateUrl: './spra-approval.component.html',
  styleUrls: ['./spra-approval.component.css']
})
export class SpraApprovalComponent implements OnInit {
  @Output("ChangeSpraApproval") ChangeSpraApproval: EventEmitter<any> = new EventEmitter();
  @Output("ChkDayOneCSA") ChkDayOneCSA: EventEmitter<any> = new EventEmitter();

  private utility: Utility;
  public SpraApprovalParams: SpraApprovalParams;
  public SPRAPriceRef :SPRAPriceRef;
  public SpraCsaRateArray: Array<SpraCsaRate> = [];
  public WarrentyMonthList: any[] = [];
  public Mode: string;
  public CompanyId:number;
  public SaleType: string;
  public IsSpraHaveFinishGood: boolean;
  public IsSpraHaveCopMfd: boolean;
  public ProdSegment : number;
  public IsDayOneCSAClick:boolean;
  public ProfitTag:boolean;
  public TotalFgValue:number;
  public IsRental:boolean = false;
  public OfficeId:number=0;
  public SPRAId:number=0;
  public Salecode:string="";
  public RefId:number=0;

  constructor(
    private _MasterService: MasterService,
    private cookieService: CookieService,
    private _NotificationService: NotificationService,
    private dialog: MatDialog,
    private router: Router
  ) {
    this.Mode = "I";
    this.SaleType = "";
    this.IsSpraHaveFinishGood = false;
    this.IsSpraHaveCopMfd = false;
    this.SpraApprovalParams = new SpraApprovalParams();
    this.SPRAPriceRef= new SPRAPriceRef();
    this.SpraCsaRateArray = new Array<SpraCsaRate>();
    this.utility = new Utility(this.cookieService);
    this.ProfitTag=false;
    this.IsDayOneCSAClick = false;
    this.ProdSegment=0;
    this.CompanyId = 0;
    this.TotalFgValue=0;
  }

  ngOnInit(): void {
  
  }


  BindWarrenty(ProdsegmentId: number, SaleTypeCode: string, WarrantyMonth: number) {
    this.WarrentyMonthList = [];
    this._MasterService.GetProductSegmentWarranty(ProdsegmentId, SaleTypeCode).subscribe((data) => {
      if (data) {
        this.WarrentyMonthList.push({ "warrantyMonth": 0, "warrantyCaption": "-- Select --" });
        this.WarrentyMonthList = this.WarrentyMonthList.concat(data);
        if(WarrantyMonth != undefined && WarrantyMonth>0){
        this.SpraApprovalParams.WarrantyMonth = WarrantyMonth;
        }else{
          this.SpraApprovalParams.WarrantyMonth = 0;
        }
      }
    }, (error) => {                              //Error callback
      this.utility.Error(error);
    });



  }


  chkDayOneCSAClick(IsDayOneCSAClick:boolean = false) {
    this.IsDayOneCSAClick = IsDayOneCSAClick;
    this.ChkDayOneCSA.emit(this.SpraApprovalParams);
    if(this.SpraApprovalParams.DayOneCSA){
      this.ResetWarrenty();
    }
  }
  A3CopyRatioChange() {
    this.ChangeSpraApproval.emit(this.SpraApprovalParams);
  }

  ResetWarrenty(){
    this.SpraApprovalParams.WarrantyMonth = 0;
    this.SpraApprovalParams.ExtraWarrentyPeriod = 0;
    this.SpraApprovalParams.WarrentyPercentage = 0;
    this.SpraApprovalParams.WarrentyCost = 0
  }


  // OnOrderRateChange()
  // {
  //   if(this.ProfitTag==true){

  //   }
  // }

  Validation(): boolean {
    if (this.SpraApprovalParams.TotalCustMif == undefined || this.SpraApprovalParams.TotalCustMif < 0) {
      this._NotificationService.showError("Please enter total customer MIF.", "Approval Required");
      return false
    }
    else if (this.IsSpraHaveFinishGood && !this.utility.CheckNumberRequired(this.SpraApprovalParams.WarrantyMonth) 
      && !this.SpraApprovalParams.DayOneCSA && !this.IsRental ) { //(this.ProdSegment!=1 && this.ProdSegment!=7) remove by rahul yadav on 24/09/2021
      this._NotificationService.showError("Please select warrenty month.", "Approval Required");
      return false
    }else if (!this.utility.CheckNumberRequiredWithZero(this.SpraApprovalParams.ConsValueThisMonth)){
      this._NotificationService.showError("Consumable order value this month can not be negative. ", "Approval Required");
      return false;
    }
    if (!this.utility.CheckNumberRequiredWithZero(this.SpraApprovalParams.SharpMifCustomerPlace)) {
      this._NotificationService.showError("Please enter Sharp Mif Customer Place value greater than 0.", "Approval Required");
      return false
    }
    if (this.SpraCsaRateArray.length > 0 && this.SaleType != 'LL' && this.SpraApprovalParams.DayOneCSA && !this.IsRental ) {
      let IsCsaRateValid: boolean = true;
      this.SpraCsaRateArray.forEach((item: SpraCsaRate) => {
        if (!this.utility.CheckNumberRequired(item.OrderRate)) {
          if(IsCsaRateValid){
            this._NotificationService.showError("Please Enter" + item.CounterDesc + "' CSA order rate ", "Approval Required");
            IsCsaRateValid = false;
          }
        }
      });
      if (!IsCsaRateValid) {
        return false;
      }
    }

    return true;

  }


  openSpraList(){

    const dialogRef = this.dialog.open(SpraListComponent, {
      width: '100%',      
      height: '85vh',
      data: { CompanyId: this.CompanyId, IsRental:this.IsRental} //IsRental added by rahul yadav on 15/6/2021
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.SpraApprovalParams.PriceRef=result.data.RequestNo;
        this.CompanyId = result.data.CompanyId;
        this.SPRAId = result.data.SpraId;
        this.OfficeId = result.data.OfficeID;
        this.RefId = result.data.RefId;
        this.Salecode = result.data.SaleCode;
      }
    });

  }

  openSpraView(){
     if(this.SPRAPriceRef.SPRAId!=undefined && this.SPRAPriceRef.SPRAId!=0){
      this.SPRAId = this.SPRAPriceRef.SPRAId;
      this.OfficeId = this.SPRAPriceRef.OfficeId;
      this.CompanyId = this.SPRAPriceRef.CompanyId;
      this.RefId = this.SPRAPriceRef.RefId;
      this.Salecode = this.SPRAPriceRef.Salecode;     
      
     }

    let data =  { IsForPriceRef:true, SPRAId: this.SPRAId,RefId:this.RefId,salecode:this.Salecode,officeId:this.OfficeId,CompanyID:this.CompanyId,ProfitTag:this.ProfitTag };

    
    const dialogRef = this.dialog.open(SpraViewOpsComponent, {
      width: '110vw',
      maxWidth:'120vw',
      height:'90%',
      data: data
      
    });
    dialogRef.afterClosed().subscribe(result => {
      if (result) {
       
      }
    });

  }

  


  CalculateWarrentyCost(){
    if(this.TotalFgValue != undefined && this.TotalFgValue >0
       && this.SpraApprovalParams.WarrentyPercentage !=undefined && this.SpraApprovalParams.WarrentyPercentage>0
       && this.SpraApprovalParams.ExtraWarrentyPeriod != undefined && this.SpraApprovalParams.ExtraWarrentyPeriod>0
       ){
        this.SpraApprovalParams.WarrentyCost = parseFloat((((this.TotalFgValue*this.SpraApprovalParams.WarrentyPercentage)/(100*12))*this.SpraApprovalParams.ExtraWarrentyPeriod).toFixed(2));

    }else if (this.TotalFgValue == undefined || this.TotalFgValue <=0){
      // alert("dsd");
      this.SpraApprovalParams.WarrentyCost = 0;
      this.SpraApprovalParams.WarrentyPercentage = 0;
    }

  }


}
